import useViewsSelector from "views/stores/useViewsSelector";
import { selectActiveQuery } from "views/logic/slices/viewSelectors";
const useCurrentQueryId = () => useViewsSelector(selectActiveQuery);
export default useCurrentQueryId;
